import gql from 'graphql-tag';

export const CREATE_ATTRACTION = gql`
mutation insert_attractions_one(
  $attraction_galleries: attractions_gallery_arr_rel_insert_input
  $council_profile_id: uuid
  $description: String
  $name: String
  $open_hours: String
  $image_url: String
  $image_path: String
  $location: geometry
  $location_text: String
  $same_open_hours: Boolean
  $type_of_attraction: String
) {
  insert_attractions_one(
    object: {
      name: $name
      open_hours: $open_hours
      type_of_attraction: $type_of_attraction
      description: $description
      image_url: $image_url
      image_path: $image_path
      location: $location
      location_text: $location_text
      same_open_hours: $same_open_hours     
      council_profile_id: $council_profile_id
      council_attraction_galleries: $attraction_galleries
    }
  ) {
    id
  }
}

`;
